import React from 'react';

export const StandardButton = ({ onClick, text }) => {
  return (
    <button className='standardButton' onClick={onClick}>
      {text}
    </button>
  );
};
